import { ref } from "vue"

// Module-level state so the about overlay shows only once per app init,
// rather than every time Home is mounted.
const showIntro = ref(true)

export function useIntro() {
  function dismissIntro() {
    showIntro.value = false
  }

  return { showIntro, dismissIntro }
}
